import constants from "../../../../appConstants";

export default class GridConfig {
    constructor(){
        this.name = "GridConfiguration";
        this.config = GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: constants.gridNames.UNRTDShipments,
      keyColumn: "proId",
      rowSelection: "single",
      rowDeselection: true,
      columns: [
        {
          headerName: "ProID",
          headerTooltip: "ProID",
          field: "proId",
          maxWidth: constants.columnWidth.PRO_ID,
          cellClass: ["gridCell-leftAlign", "actionable-cell"],
        },
        {
          headerName: "Reason",
          field: "explanation",
          cellClass: "gridCell-leftAlign",
          headerTooltip: "Reason",
          tooltipField: "explanation",
        },
      ]
    };
  }
}
